import { BaseSearchModel } from "../../query/base-search.model";
import { AccountStatus } from "../user/user.model";

export class ClientSearchModel extends BaseSearchModel {
    name?: string;
    lastName?: string;
    clientId?: string;
    number?: string;
    phoneNumber?: string;
    matterNumber?: string;
    fullName?: string;
    socialId?: string;
    businessUnitId?: string;
    userName?: string;
    email?: string;
    createdById?: string; 
    status?: AccountStatus;
    isEnabled?: boolean;
}